goog.provide("shadow.js.shim.module$$embedpdf$plugin_annotation");
goog.provide("module$shadow_js_shim_module$$embedpdf$plugin_annotation");
shadow.js.shim.module$$embedpdf$plugin_annotation = shadow.js.nativeProvides["@embedpdf/plugin-annotation"] = shadow$bridge("@embedpdf/plugin-annotation");
module$shadow_js_shim_module$$embedpdf$plugin_annotation.default = shadow.js.shim.module$$embedpdf$plugin_annotation;
